import { CircularProgress } from "@mui/material";
import useDataFetching from "hooks/useDataFetching";
import { useEffect, useState } from "react";
import { formatDate } from "utils";
import { config } from "variables/config";
import { useTranslation } from "react-i18next"; // Import useTranslation

const StatsCardDemande = () => {
  const { t } = useTranslation("demands"); // Use the 'demands' namespace

  const [loadingStats, errors, contractStats, getStats] = useDataFetching(
    `${config.app.api_url}/contracts/stats-details`
  );

  const Card = ({ label, value, loading }) => {
    return (
      <div className="flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l">
        <dt className="order-2 mt-2 text-lg leading-6 font-medium text-gray-500">
          {label}
        </dt>
        {loading ? (
          <CircularProgress className="mx-auto" color="success" />
        ) : (
          <dd className="order-1 text-4xl font-extrabold text-green-500">{value}</dd>
        )}
      </div>
    );
  };

  const getValue = (value) => {
    return value == null || value == undefined ? "0" : value;
  };

  return (
    <>
      <div className="bg-gray-50 py-4 ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              {t("demands_title")} {/* Translated */}
            </h2>
            <p className="mt-3 text-xl text-gray-500 sm:mt-2">
              {t("demands_stats_description")} {/* Translated */}
            </p>
          </div>
        </div>
        <div className="mt-5 pb-1">
          <div className="relative">
            <div className="absolute inset-0 h-1/2 bg-gray-50"></div>
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="max-w-7xl mx-auto">
                <dl className="rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-5">
                  <Card
                    loading={loadingStats}
                    label={t("new_enterprises_collected")} /* Translated */
                    value={getValue(contractStats?.data?.total)}
                  />
                  <Card
                    loading={loadingStats}
                    label={t("demands_pending")} /* Translated */
                    value={getValue(contractStats?.data?.pending)}
                  />
                  <Card
                    loading={loadingStats}
                    label={t("demands_evaluated")} /* Translated */
                    value={getValue(contractStats?.data?.evaluated)}
                  />
                  <Card
                    loading={loadingStats}
                    label={t("demands_available")} /* Translated */
                    value={getValue(contractStats?.data?.available)}
                  />
                  <Card
                    loading={loadingStats}
                    label={t("demands_taken")} /* Translated */
                    value={getValue(contractStats?.data?.taken)}
                  />
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatsCardDemande;